import React, { Component } from 'react';

import classNames from 'classnames';
import { ButtonIcon } from 'components/button';
import { DataTable } from 'components/dataTable';
import { Grid } from 'components/grid';
import { Loader } from 'components/loader';
import { ProgressBar } from 'components/progressBar';
import { I18n, translate } from 'components/translate';
import ClubDate from 'helpers/ClubDate';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { BroadcastService } from 'modules/broadcastManager';
import { BroadcastDetail } from 'modules/broadcastManager/broadcastDetail';
import PropTypes from 'prop-types';

import { FORMATS } from '../../../../helpers/ClubDate';
import BroadcastEmptyContent from '../broadcastEmptyContent/BroadcastEmptyContent';

import './BroadcastList.scss';

const MAX_PERCENTAGE = 100;

@inject('BroadcastStore')
@translate()
@observer
export default class BroadcastListContent extends Component {
  static propTypes = {
    t: PropTypes.func,
    BroadcastStore: MobxPropTypes.objectOrObservableObject
  };

  state = {
    loaded: false,
    broadcastModal: {
      showBroadcastModal: false,
      messageId: null,
      title: '',
      message: ''
    }
  };

  fetchItems = async () => {
    await BroadcastService.getBroadcasts();
  };

  async componentDidMount() {
    this.setState({ loaded: false });
    await this.fetchItems();
    this.setState({ loaded: true });
  }

  formatDate(date) {
    return date && ClubDate.resolve(date).format(FORMATS.DDMMYYYY_HHMM);
  }

  formatProgressClassName = (progress) => {
    let className = 'broadcast__progress';
    const maxPercentage = MAX_PERCENTAGE;

    className = classNames(className, {
      [`${className}--complete`]: progress >= maxPercentage
    });

    return className;
  };

  closeBroadcastModal = () => {
    this.setState({
      broadcastModal: {
        showBroadcastModal: false,
        messageId: null,
        title: '',
        message: ''
      }
    });
  };

  openBroadcastModal = (messageId, title, message) => {
    this.setState({
      broadcastModal: {
        showBroadcastModal: true,
        messageId,
        title,
        message
      }
    });
  };

  renderBroadcastModal = () => {
    const { broadcastModal } = this.state;

    return (
      <BroadcastDetail
        broadcast={broadcastModal}
        onClose={this.closeBroadcastModal}
      />
    );
  };

  get columns() {
    return [
      { name: 'userName', label: 'general.name' },
      { name: 'userSendDate', label: 'broadcast.send_date' },
      { name: 'userReadingMessage', label: 'broadcast.reading_the_message' },
      { name: 'actions', label: '' }
    ];
  }

  changePage = (page) => {
    const { listBroadcast } = this.props.BroadcastStore;

    BroadcastService.setData({
      listBroadcast: {
        ...listBroadcast,
        pagination: {
          ...listBroadcast.pagination,
          page
        }
      }
    });
    this.fetchItems();
  };

  changePerPage = (perPage) => {
    const { listBroadcast } = this.props.BroadcastStore;

    BroadcastService.setData({
      listBroadcast: {
        ...listBroadcast,
        pagination: {
          ...listBroadcast.pagination,
          page: 0,
          perPage
        }
      }
    });

    this.fetchItems();
  };

  renderCommentItem = (item, index) => {
    const percentageValue = Math.min(item.completionPercentage, MAX_PERCENTAGE);
    const { messageId, title, content, sendDate, completionPercentage } =
      item || {};

    return (
      <DataTable.Row
        key={`${messageId}${index}`}
        onClick={() => this.openBroadcastModal(messageId, title, content)}
      >
        <DataTable.DataColumns>
          <DataTable.Cell>
            <span className="broadcast__title">{title}</span>
          </DataTable.Cell>
          <DataTable.Cell>
            <span className="broadcast__date">{this.formatDate(sendDate)}</span>
          </DataTable.Cell>
          <DataTable.Cell>
            <div className={this.formatProgressClassName(completionPercentage)}>
              <div>{`${percentageValue}%`}</div>
              <ProgressBar progress={percentageValue} />
            </div>
          </DataTable.Cell>
          <DataTable.Cell>
            <ButtonIcon
              size="small"
              transparent
              icon="plus"
              className="broadcast__more"
            >
              <I18n label="broadcast.view_broadcast" />
            </ButtonIcon>
          </DataTable.Cell>
        </DataTable.DataColumns>
      </DataTable.Row>
    );
  };

  renderContent = () => {
    const { showBroadcastModal } = this.state.broadcastModal;
    const { listBroadcast } = this.props.BroadcastStore;
    const { pagination, content = [] } = listBroadcast || {};

    return (
      <Grid block className="broadcast">
        <h2>
          <I18n label="broadcast.sent_broadcast" />
        </h2>
        <p>
          <I18n label="broadcast.students_sent_messages" />
        </p>
        <div className="broadcast__list">
          <DataTable
            columns={this.columns}
            pagination={pagination}
            onChangePerPage={this.changePerPage}
            onChangePage={this.changePage}
          >
            <DataTable.Header>
              <DataTable.Row>
                <DataTable.Header.Columns />
              </DataTable.Row>
            </DataTable.Header>

            <DataTable.Body>
              {content.map((item, index) =>
                this.renderCommentItem(item, index)
              )}
            </DataTable.Body>

            <DataTable.Footer />
          </DataTable>
        </div>
        {showBroadcastModal && this.renderBroadcastModal()}
      </Grid>
    );
  };

  render() {
    const { loaded } = this.state;
    const { listBroadcast } = this.props.BroadcastStore;

    if (!loaded) {
      return <Loader key="loader" />;
    } else if (!listBroadcast.pagination.numberOfElements) {
      return <BroadcastEmptyContent />;
    } else {
      return this.renderContent();
    }
  }
}
